import { Component, ElementRef, ViewChild } from '@angular/core'
import { MatMenu } from '@angular/material/menu'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ApiService, AppService, ClinicService } from '@mmx/shared'
import { throttle } from 'lodash'

declare const Upscope: any

interface ZoomMeetingResponse {
  id: string
  meeting: string
  phone: string
}

@Component({
  selector: 'mmx-help-icon',
  templateUrl: 'help-icon.component.html',
  styleUrls: ['./help-icon.component.scss'],
  standalone: false,
})
export class HelpIconComponent {
  @ViewChild('helpButton') helpButton: MatMenu
  @ViewChild('helpButtonContainer')
    helpButtonContainer: ElementRef<HTMLDivElement>
  @ViewChild('helpMenu') helpMenu: MatMenu

  hasUpscope: boolean
  requestingAgent = false
  startingScreenShare = false
  agentsAvailable = false
  agentAccepted = false
  zoomMeetingId: string | undefined
  zoomMeetingUrl: string | undefined
  zoomMeetingPhone: string | undefined
  _onDrag: any

  get hasSupportPlan(): boolean {
    return this.clinicService.clinic.settings.supportPlan !== 'basic'
  }

  constructor(
    public app: AppService,
    private clinicService: ClinicService,
    private snackBar: MatSnackBar,
    private restService: ApiService,
  ) {
    this._onDrag = throttle(() => {
      const classList = this.helpButtonContainer.nativeElement.classList
      classList.toggle('pos-left')
    }, 5000)

    if (typeof Upscope !== 'undefined') {
      this.hasUpscope = true

      Upscope('on', 'agentsAvailable', () => {
        this.agentsAvailable = true
      })

      Upscope('on', 'agentRequestUpdate', (update: 'pending' | 'accepted') => {
        if (update === 'accepted') {
          this.requestingAgent = false
          this.agentAccepted = true
        }
      })
    }
  }

  onDrag() {
    this._onDrag()
  }

  requestAgent(event) {
    if (!this.hasUpscope) {
      return this.startScreenShare(event)
    }

    event.stopImmediatePropagation()
    this.requestingAgent = true
    this.startingScreenShare = true
    Upscope('requestAgent')
    Upscope('getLookupCode', (lookupCode) => {
      Upscope('getWatchLink', (watchLink) => {
        const body = {
          method: 'upscope',
          lookupCode,
          watchLink,
        }
        const route = '/clinicians/screen-share'
        this.restService.post<ZoomMeetingResponse>(route, body).subscribe(
          (resp) => {
            this.zoomMeetingId = resp.data.id
            this.zoomMeetingUrl = resp.data.meeting
            this.zoomMeetingPhone = resp.data.phone
            this.startingScreenShare = false
          },
          () => {
            this.startingScreenShare = false
            this.snackBar.open(
              'An error occurred while trying to notify agents of your request',
              undefined,
              {
                duration: 2000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              },
            )
          },
        )
      })
    })
  }

  cancelRequestAgent() {
    this.requestingAgent = false
    this.zoomMeetingId = null
    this.zoomMeetingUrl = null
    this.zoomMeetingPhone = null
    Upscope('cancelRequestAgent')
  }

  startScreenShare(event: MouseEvent) {
    event.stopImmediatePropagation()
    this.startingScreenShare = true
    const route = '/clinicians/screen-share'
    const body = { method: 'zoom' }
    this.restService.post<ZoomMeetingResponse>(route, body).subscribe(
      (resp) => {
        this.startingScreenShare = false
        this.zoomMeetingId = resp.data.id
        this.zoomMeetingUrl = resp.data.meeting
        this.zoomMeetingPhone = resp.data.phone
        const win = window.open(resp.data.meeting)

        if (!win) {
          const snack = this.snackBar.open('Join screen share', 'Join', {
            duration: 0,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            data: {
              meeting: resp.data.meeting,
            },
          })

          snack.onAction().subscribe(() => {
            window.open(this.zoomMeetingUrl)
          })
        }
      },
      () => {
        this.startingScreenShare = false
        this.snackBar.open(
          'An error occurred while trying to start a screen share request',
          undefined,
          {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          },
        )
      },
    )
  }
}
